<template>
  <div
    class="box-icon d-flex align-items-center justify-content-center"
    :style="[
      {backgroundColor: bg},
      
    ]">
    <i v-if="icon" :class="`fas fa-${icon} fs-22`" :style="{color: iColor}"></i>
    <img v-else-if="img" :src="img" />
  </div>
</template>

<script>
  export default {
    props:{
      bg: {
        type: String,
        default: '#fff'
      },
      icon: String,
      img: String,
      iColor: {
        type: String,
        default: '#fff'
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>